import { ApiAsset } from '@/components/app/cards/PacksList/types';
import { Guide } from '@/store/guide/types';
import { MeditationType } from '@/store/program/types';

import { useProgramState } from '../store';

type ProgramInfo = {
	guides?: Guide[];
	backgroundImage?: ApiAsset;
	image?: ApiAsset;
	trailer?: Guide;
};

export const useProgramInfo = (): ProgramInfo => {
	const program = useProgramState();

	if (!program) {
		return {};
	}

	const image = program.titled_background_image ?? program.background_image ?? program.guides?.[0].cell_image;
	const backgroundImage = program.background_image ?? program.guides?.[0].cell_image;

	const getProgramGuides = () => {
		const isMasterclass = program.meditation_type === MeditationType.MasterClass;
		return program.guides
			?.filter(guide => (isMasterclass ? !guide.is_trailer : true))
			.sort((a, b) => (a.position > b.position ? 1 : -1));
	};

	const trailer = program.guides?.find(guide => guide.is_trailer);

	return {
		guides: getProgramGuides(),
		backgroundImage,
		image,
		trailer,
	};
};
